import AlignmentHOC from "./alignmentHOC"

export type { AlignmentHOCProps } from './interface'
export default AlignmentHOC
